import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 100, // 测试用
    hasLogin: null, //是否登陆
    //  用户信息
    userINfo: {},
    // token: '', // 登陆令牌
    // avatarUrl: '', // 登陆头像
    // userName: '' // 登陆用户名


  },
  mutations: {
    login (state, provider) {
      console.log("保存用户信息");
      // console.log(provider);
      // console.log(provider.token);
      // id 为微信的openid
      state.hasLogin = true;
      state.userINfo.token = provider.token;
      state.userINfo.userName = provider.username;
      state.userINfo.avatarUrl = provider.avatarUrl;
      state.userINfo.userId = provider.userId;
      state.userINfo.openId = provider.openId;
      state.userINfo.gender = provider.gender

      // 存储
      let user = JSON.stringify(state.userINfo)
      localStorage.setItem("userInfo", user);
      // let p = localStorage.getItem('userInfo');  //读取文件
      // console.log(JSON.parse(p))
    },
    logout (state) {
      console.log("清除用户信息，退出登陆");
      state.hasLogin = false;
      state.userINfo = {};
      // 取用
      // localStorage.getItem("userInfo");
      localStorage.removeItem('userInfo');  //清除文件
    },
  }

})

export default store